import script from "./MobileNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileNavbar.vue?vue&type=script&setup=true&lang=js"

import "./MobileNavbar.vue?vue&type=style&index=0&id=521d3200&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521d3200"]])

export default __exports__